const pinColorSliders = () => {
  const el = "color-slider";
  document.querySelectorAll(`.${el}`).forEach((slider) => {
    const slidePager = slider.querySelectorAll(`.${el}__pager > li`);
    const slideCount = slidePager.length;

    if (
      slideCount <= 1 || //Too few slides
      window.innerWidth <= Theme.breakpoints.lg || //Mobile screen
      !!document.querySelector(".reveal-hero") //Reveal hero exists
    )
      return;

    gsap.timeline({
      scrollTrigger: {
        trigger: slider.querySelector(`.${el}__inner`),
        pin: document.querySelector("#MainContent"),
        pinnedContainer: document.querySelector("#MainContent"),
        // pin: true,
        // pinSpacing: false,

        start: "center center",
        end: `+=${
          slider.querySelector(`.${el}__inner`)?.offsetHeight * slideCount
        }`,
        scrub: true,
        onUpdate: ({ progress }) => {
          //Click the correct pager when we've scrolled to the correct percent of the flow
          if (progress == 1) return;
          const activePagerIndex = Math.floor(
            (progress * 100) / (100 / (slidePager.length + 1))
          );
          const activePager = slidePager[activePagerIndex]?.querySelector('a');
          if (activePager && !activePager.classList?.contains("active")) {
            activePager?.click();
          }
        }
      },
    });
  });
}
document.addEventListener("alpine:init", () =>
  setTimeout(pinColorSliders, 100)
);
